import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { App } from '@/app/App';
import { assertProductionConfig } from '@/config/env';
import { setUpdateAvailable } from '@/lib/app-update';
import { logError, log } from '@/lib/observability';
import '@/styles/index.css';

// Una configurazione di produzione incompleta deve fallire subito e in modo
// rumoroso, non degradare silenziosamente in modalità dimostrativa.
assertProductionConfig();

// Errori non gestiti e promise rifiutate finiscono nel log strutturato invece
// di scomparire nella console del browser dell'operatore.
window.addEventListener('error', (event) => logError(event.error ?? event.message, { source: 'window' }));
window.addEventListener('unhandledrejection', (event) =>
  logError(event.reason, { source: 'unhandledrejection' }),
);

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root non trovato in index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Il service worker non si aggiorna da solo durante il servizio: sostituire il
// codice mentre un cameriere sta prendendo un ordine è il modo migliore per
// perdere il suo lavoro. La nuova versione è segnalata da un avviso e applicata
// quando la persona preme «Aggiorna».
const updateSW = registerSW({
  onNeedRefresh() {
    log.info('Aggiornamento di Bacco disponibile.');
    setUpdateAvailable(() => updateSW(true));
  },
  onOfflineReady() {
    log.info('Bacco è disponibile offline per le funzioni di sola consultazione.');
  },
  onRegisteredSW(_url, registration) {
    // Un'app lasciata aperta tutto il giorno controlla comunque gli
    // aggiornamenti, non solo al primo caricamento.
    if (registration) setInterval(() => void registration.update(), 30 * 60_000);
  },
});
